import React from 'react';
import { UserSettings } from '../../types/index';

interface BusinessInfoCardProps {
  preferences: UserSettings;
  onUpdate?: (preferences: UserSettings) => void;
}

const BusinessInfoCard: React.FC<BusinessInfoCardProps> = ({ preferences, onUpdate }) => {
  const handleChange = (field: string, value: string) => {
    if (onUpdate) {
      onUpdate({
        ...preferences,
        [field]: value,
      });
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md mb-6">
      <h2 className="text-xl font-semibold text-primary mb-4">Información del Negocio</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-primary text-sm font-bold mb-2">Nombre del Negocio</label>
          <input
            type="text"
            value={preferences.name || ''}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Nombre de tu negocio"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        <div>
          <label className="block text-primary text-sm font-bold mb-2">
            Descripción Breve del Negocio
            <span className="text-gray-500 font-normal ml-2">
              ({preferences.businessDescription?.length || 0}/300 caracteres)
            </span>
          </label>
          <textarea
            value={preferences.businessDescription || ''}
            onChange={(e) => {
              if (e.target.value.length <= 300) {
                handleChange('businessDescription', e.target.value);
              }
            }}
            placeholder="Breve descripción de tu negocio (máximo 300 caracteres)"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary h-24"
            maxLength={300}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessInfoCard;
